import { foreignKey, index, pgTable, uuid, varchar } from 'drizzle-orm/pg-core';
import { sql } from 'drizzle-orm';
import { organization_site } from '@trashlab/api/src/domains/dispatch/schemas/organization-site';
import { customerSite } from '@trashlab/api/src/domains/customer/schemas/customer-site';
import { vehicles } from '@trashlab/api/src/domains/asset/schemas/vehicles';
import {
  defaultFields,
  defaultHistoryFields,
} from '@trashlab/api/drizzle/default';

export const location = pgTable(
  'location',
  {
    ...defaultFields.fieldsWithTenantId(),
    lastModifiedBy: uuid('lastModifiedBy'),
    createdBy: uuid('createdBy'),
    legacySystemId: varchar('legacySystemId', { length: 255 }),
    organizationSiteId: uuid('organizationSiteId'),
    customerSiteId: uuid('customerSiteId'),
    vehicleId: uuid('vehicleId'),
    uniqueId: uuid('uniqueId').notNull(),
  },
  (table) => {
    return {
      site_merge_page_idx: index('location_site_merge_page_idx').on(
        table.tenantId,
        table.customerSiteId,
        table.id,
      ),
      createdAtTs_idx: index('location_createdAtTs_idx').on(table.createdAtTs),
      tenantId_idx: index('location_tenantId_idx').on(table.tenantId),
      tenant_organization_site_active_idx: index('location_tenant_organization_site_active_idx')
        .on(table.tenantId, table.organizationSiteId, table.id)
        .where(sql`${table.archivedAtTs} IS NULL`),
      updatedAtTs_idx: index('location_updatedAtTs_idx').on(table.updatedAtTs),
      updatedAtTs_idx1: index('location_updatedAtTs_idx1').on(
        table.updatedAtTs.desc(),
      ),
      versionNumber_idx: index('location_versionNumber_idx').on(
        table.versionNumber,
      ),
      customerSiteId_idx: index('location_customerSiteId_idx').on(
        table.customerSiteId,
      ),
      vehicleId_idx: index('location_vehicleId_idx').on(table.vehicleId),

      //foreign keys
      location_customerSiteId_fkey: foreignKey({
        columns: [table.customerSiteId],
        foreignColumns: [customerSite.id],
        name: 'location_customerSiteId_fkey',
      }),
      location_organizationSiteId_fkey: foreignKey({
        columns: [table.organizationSiteId],
        foreignColumns: [organization_site.id],
        name: 'location_organizationSiteId_fkey',
      }),
      location_vehicleId_fkey: foreignKey({
        columns: [table.vehicleId],
        foreignColumns: [vehicles.id],
        name: 'location_vehicleId_fkey',
      }),
    };
  },
);

export const location_history = pgTable('location_history', {
  ...defaultHistoryFields.historyFieldsWithTenantId(),
  lastModifiedBy: uuid('lastModifiedBy'),
  createdBy: uuid('createdBy'),
  legacySystemId: varchar('legacySystemId', { length: 255 }),
  organizationSiteId: uuid('organizationSiteId'),
  customerSiteId: uuid('customerSiteId'),
  uniqueId: uuid('uniqueId'),
  vehicleId: uuid('vehicleId'),
});
